{
  "pages": [
    {
      "name": "Load info",
      "elements": [
        {
          "type": "panel",
          "name": "panel1",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "dropdown",
              "name": "Application",
              "title": "What is the application?",
              "isRequired": true,
              "choices": [
                {
                  "value": "RadiatorOneStringHeating",
                  "text": "Radiator one string"
                },
                {
                  "value": "RadiatorTwoStringHeating",
                  "text": "Radiator two string"
                },
                {
                  "value": "UnderfloorHeating",
                  "text": "Underfloor Heating"
                },
                {
                  "value": "UnknownApplication",
                  "text": "Unknown"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "Weather_compensation_enabled",
              "title": "Weather compensation enabled?",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            }
          ],
          "title": "Load info",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "Heat Meter",
          "elements": [
            {
              "type": "boolean",
              "name": "HM_present",
              "title": "Heat meter needed?",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            },
            {
              "type": "dropdown",
              "name": "HM_location",
              "visibleIf": "{HM_present} = true",
              "title": "Where is the heat meter placed?",
              "isRequired": true,
              "choices": [
                {
                  "value": "PrimaryForward",
                  "text": "Forward"
                },
                {
                  "value": "PrimaryReturn",
                  "text": "Return"
                }
              ]
            },
            {
              "type": "text",
              "name": "HM_address",
              "visibleIf": "{HM_present} = true",
              "isRequired": true,
              "title": "Bus address",
              "inputType": "number"
            }
          ],
          "title": "Heat Meter",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "Temperature_sensors_needed",
          "elements": [
            {
              "type": "boolean",
              "name": "T_F_present",
              "title": "Forward temperature sensor",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_R_present",
              "title": "Return temperature sensor",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "visible": false,
          "visibleIf": "{HM_present} = false",
          "title": "Temperature sensors needed"
        },
        {
          "type": "panel",
          "name": "panel2",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_F_sensortype",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visible": false,
          "visibleIf": "{T_F_present} = true",
          "title": "Forward temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel11",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_R_sensortype",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visible": false,
          "visibleIf": "{T_R_present} = true",
          "title": "Return temperature sensor details"
        }
      ]
    }
  ]
}